import liff from "@line/liff";
import { setLineInfo } from "../store/actions/prescription";
import store from "../store";
import { ERROR } from "../routes/path";

export const closeWindow = (navigate, destination) => {
  if (!!navigate && !!destination) {
    navigate(destination, { replace: true });
  } else {
    liff.closeWindow();
  }
};

const mockLIne = () =>
  Promise.resolve({
    userId: "testlineid5",
    displayName: "test",
  });

const getLineProfile = async () => {
  try {
    if (process.env.NODE_ENV === "development") {
      // react単体でローカル起動時、lineから情報もらえない場合のdummy dataを設定
      const lineProfile = await mockLIne();
      store.dispatch(
        setLineInfo({
          liffId: "1657811929-4AMr6LXd",
          lineId: lineProfile.userId,
          userName: lineProfile.displayName,
        })
      );
      return lineProfile;
    } else {
      const params = new URLSearchParams(window.location.search);
      const liffId = params.get("liffId");
      if (liffId) {
        await liff.init({ liffId: liffId });
        if (liff.isInClient()) {
          console.log("ERROR: line以外起動");
        }
        if (liff.isLoggedIn()) {
          const lineProfile = await liff.getProfile();
          store.dispatch(
            setLineInfo({
              liffId: liffId,
              lineId: lineProfile.userId,
              userName: lineProfile.displayName,
            })
          );
          return lineProfile;
        } else {
          liff.login();
        }
      } else {
        console.log("Error: GET WRONG LIFF ID FROM URL");
        window.location.href = ERROR;
      }
    }
  } catch (e) {
    console.log("Error initializing LIFF:", e);
    window.location.href = ERROR;
  }
};

export default getLineProfile;
